module.exports = __webpack_public_path__ + "TB_Eating_Melody_B.wav.89fb82fe.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/eating/TB_Eating_Melody_B.wav.mp3
// module id = 493
// module chunks = 0